export default {"src":"/_next/static/media/DEVELOPER_DETAILS_ICON.b9d9b020.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};